export { default, default as InteractiveIcon } from './InteractiveIcon'
export { default as interactiveIconTheme } from './themes/InteractiveIcon.theme'
export * as InteractiveIconStyles from './styles/InteractiveIcon.style'

export type { InteractiveIconProps } from './InteractiveIcon.types'
export type { AppearanceKeys, InteractiveIconTheme } from './themes/InteractiveIcon.theme.types'
export type { StyledInteractiveIconProps } from './styles/InteractiveIcon.style.types'
